export default class CodeRomeDto {
  id;
  code;
  libelle;
  poleEmploi;
  verifie;
  type;
  customType;
  presentSynthese;
}